<template>
  <div class="code-mirror-editor">
    <codemirror
      v-model="inputCode"
      :options="options"
      :closetag="true"
      ref="editor"
    />
    <transition name="lint">
      <div class="lint-error">
        <div class="lint-error-inner" v-if="lintErrorCount > 0">
          <span class="lint-error-text">
            ※
          </span>
          <span class="lint-error-count">
            {{ lintErrorCount }}
          </span>
          <span class="lint-error-text">
            件の構文エラーがあります
          </span>
        </div>
        <div class="lint-error-inner" v-else-if="isBadHTML">
          <span class="lint-error-text">
            ※ {{ mode === 'htmlmixed' ? 'HTMLが' : '' }} 不正な形式です
          </span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { codemirror } from 'vue-codemirror'
import { CSSLint } from 'csslint'
import 'codemirror/lib/codemirror.css'
import 'codemirror/mode/htmlmixed/htmlmixed.js'
import 'codemirror/addon/edit/closebrackets.js'
import 'codemirror/addon/edit/closetag.js'
import 'codemirror/addon/display/placeholder.js'
import 'codemirror/addon/lint/lint.css'
import 'codemirror/addon/lint/lint.js'
import 'codemirror/addon/lint/html-lint.js'
import 'codemirror/addon/lint/css-lint.js'
window.CSSLint = CSSLint

export default {
  props: [
    'mode',
    'code',
    'placeholder',
  ],
  data () {
    return {
      lintErrorCount: 0,
      isBadHTML: false,
      observer: null,
    }
  },
  components: {
    codemirror
  },
  methods: {
    showLintResult (annotations) {
      this.isBadHTML = false
      if (!annotations || annotations.length === 0) {
        this.lintErrorCount = 0
        if (this.$refs.editor && this.$refs.editor.$el.getElementsByClassName('cm-error').length > 0) {
          // エラー用のクラスが存在していたらエラー文言を表示させる
          this.isBadHTML = true
        }
      } else {
        // annotation 配列からエラー件数を表示させる
        // filter(Boolean) 空配列除去
        this.lintErrorCount = annotations.filter(Boolean).length
      }
    },
  },
  mounted () {
    // テキストエリアの幅を変更するとカーソル位置がクリックしたところへ行かない
    // 幅を監視して、変更があればリフレッシュする
    // https://github.com/codemirror/CodeMirror/issues/1642
    this.observer = new ResizeObserver(entries => {
      this.$refs.editor.refresh()
    })
    this.observer.observe(this.$refs.editor.$el)
  },
  beforeDestroy () {
    this.observer.disconnect(this.$refs.editor.$el)
  },
  computed: {
    options () {
      return {
        mode: this.mode,
        theme: 'default',
        tabSize: 2,
        indentUnit: 2,
        indentWithTabs: true,
        lineNumbers: true,
        lint: {
          // https://github.com/codemirror/CodeMirror/issues/4198
          onUpdateLinting: (_annotationsNotSorted, annotations) => {
            this.showLintResult(annotations)
          },
          options: {},
        },
        line: true,
        lineWrapping: true,
        dragDrop: false,
        autoCloseBrackets: true,
        autoCloseTags: {
          whenClosing: false,
          whenOpening: true,
          indentTags: [],
        },
        gutters: [
          'CodeMirror-lint-markers',
        ],
        placeholder: this.placeholder || '',
      }
    },
    inputCode: {
      get () {
        return this.code
      },
      set (newValue) {
        if (this.code !== newValue) {
          this.$emit('change', newValue)
        }
      }
    },
  }
}
</script>

<style lang="scss">
.CodeMirror pre.CodeMirror-placeholder {
  color: #A7A7A7;
}
</style>

<style scoped lang="scss">
.code-mirror-editor {
  padding-right: 10px;
}

.lint-error {
  display: block;
  margin: 5px 3px 5px 45px;
  &-inner {
    color: #dd6a59;
    padding: 1px 3px;
    background-color: #f7d9d5;
    border-radius: 5px;
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;
  }
  &-count {
    padding: 0 8px;
    font-size: 14px;
    font-weight: 700;
  }
  &-text {
    font-size: 14px;
  }
}
.lint-enter-active, .lint-leave-active {
  transition: opacity 0.1s linear;
}
.lint-enter, .lint-leave-to {
  opacity: 0;
}
.lint-enter-to, .lint-leave {
  opacity: 1;
}
</style>
